module.exports = {
    EMPLOYEE: 1,
    CANDIDATE: 2,
};



//////////////////
// WEBPACK FOOTER
// ./src/constants/position-types.js
// module id = 126
// module chunks = 58